module.exports = __webpack_public_path__ + "img/cat-empty-ingresos-white.6669077e.svg";